import { createI18n } from 'vue-i18n'

import en from './locales/en.json'
import sharedEn from '@repo/ui/locales/en'

const messages = {
  en: { ...en, ...sharedEn },
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n

type Paths<T> = T extends object
  ? { [K in keyof T]: K extends string ? (T[K] extends object ? `${K}.${Paths<T[K]>}` : K) : never }[keyof T]
  : never

export type I18nKey = Paths<typeof messages.en>
